import React from 'react'
import Panel from '../Panel'
import { dGet } from '@core/utils'
import LabelText from '../LabelText'

const CooperationCard = ({ item, operator }) => {
  const { new_support, old_support } = dGet(item, 'cooperation_card', {})

  return (
    <Panel
      icon="//qnm.hunliji.com/o_1d8n8ueul1ji83dv1qi52ga19na12.png"
      item={item}
    >
      <LabelText label="修改后负责人" block>
        {new_support}
      </LabelText>

      <LabelText label="原负责人" block>
        {old_support}
      </LabelText>

      <LabelText label="操作人" block>
        {operator}
      </LabelText>
    </Panel>
  )
}

export default CooperationCard
